var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6407 0C8.75598 0 11.2812 2.46257 11.2812 5.50009C11.2812 8.53762 8.75578 11 5.6407 11C2.52561 11 0 8.53762 0 5.50009C0 2.46257 2.52542 0 5.6407 0ZM14.6485 0.322181C16.2061 0.322181 17.4688 2.64018 17.4688 5.50009H17.469C17.469 8.35926 16.2063 10.678 14.6487 10.678C13.091 10.678 11.8283 8.35926 11.8283 5.50009C11.8283 2.64092 13.0908 0.322181 14.6485 0.322181ZM19.0081 0.861501C19.5558 0.861501 20 2.93823 20 5.50009C20 8.06121 19.556 10.1387 19.0081 10.1387C18.4602 10.1387 18.0163 8.06177 18.0163 5.50009C18.0163 2.93842 18.4604 0.861501 19.0081 0.861501Z",
    fill: "#02004B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.4ea26ef9.svg";
export { ForwardRef as ReactComponent };